import React, { ReactNode } from 'react';
// CSSはインポートした順に生成され、後にインポートしたCSSの方が優先されるので、
// まず他のコンポーネントや共通CSSをインポートして、その後でコンポーネントごとのCSSをインストールすること
// つまり、styles.module.cssのインポートはインポート文の複数行のうちの最後に置いておくのが安全
import styles from './styles.module.css';

export type FontMonospacedNumProps = {
    className?: string;
    domType?: string;
    children?: ReactNode;
};


const FontMonospacedNum : React.FC<FontMonospacedNumProps> = ({
    className = '',
    domType = undefined,
    children,
}) => {
    // class属性を設定
    let classString = styles['font-monospaced-num'];
    if (className) {
        classString = [classString, className].join(' ');
    }

    if (domType === 'span') {
        return (
            <span className={classString} data-testid='span-font-monospaced-num'>{children}</span>
        )
    } else if(domType === 'p') {
        return (
            <p className={classString} data-testid='p-font-monospaced-num'>{children}</p>
        )
    } else { // デフォルトはdiv
        return (
            <div className={classString} data-testid='div-font-monospaced-num'>{children}</div>
        )
    }
};

export default FontMonospacedNum;
